/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_BodyInputs */

const en_platform_hero_body = /** @type {(inputs: Platform_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients book themselves from your page, plans and progress live in one place, and reminders go out without you. One app instead of six.`)
};

const pl_platform_hero_body = /** @type {(inputs: Platform_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podopieczni rezerwują sami z Twojej strony, plany i postępy czekają w jednym miejscu, a przypomnienia wychodzą bez Ciebie. Jedna aplikacja zamiast sześciu.`)
};

/**
* | output |
* | --- |
* | "Clients book themselves from your page, plans and progress live in one place, and reminders go out without you. One app instead of six." |
*
* @param {Platform_Hero_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_body = /** @type {((inputs?: Platform_Hero_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_body(inputs)
	return en_platform_hero_body(inputs)
});